import { replaceSpecialChars } from "./Utilities";

import type { GetMediaResponse } from "../api/MediaAPI.types";
import type {
  SmartlistTranslation,
  SmartlistTranslationToCreate,
} from "../api/SmartlistAPI.types";
import type { Picture } from "../types";

// todo : A terme il ne faudra plus utiliser pictures mais picture, remplacer l'utilisation de cette fonction par celle de hasCoverPicture
export const checkCoverPictureOldVersion = (translation: {
  pictures: Picture;
  temp_pictures: Picture;
  cover_picture_16_6: string;
  cover_picture_16_9: string;
  cover_picture_3_4: string;
  cover_picture_1_1: string;
}): boolean => {
  if (
    !translation.pictures &&
    !translation.temp_pictures &&
    !translation.cover_picture_16_6 &&
    !translation.cover_picture_16_9 &&
    !translation.cover_picture_3_4 &&
    !translation.cover_picture_1_1
  ) {
    return false;
  }

  return true;
};

export const hasCoverPicture = (
  translation: SmartlistTranslation | SmartlistTranslationToCreate,
): boolean => {
  if (
    translation.picture?.cover_picture_16_6 &&
    translation.picture.cover_picture_16_9 &&
    translation.picture.cover_picture_3_4 &&
    translation.picture.cover_picture_1_1
  ) {
    return true;
  }

  return false;
};

export const checkISANCode = (item: GetMediaResponse): boolean => {
  const isanRegex =
    /^ISAN\s([0-9A-F]{4}-){4}[0-9A-Z]-([0-9A-F]{4}-){2}[0-9A-Z]$/;

  if (
    item.isan_code &&
    item.isan_code.length > 0 &&
    isanRegex.exec(item.isan_code) === null
  ) {
    return false;
  }

  return true;
};
export const checkEIDRCode = (item: GetMediaResponse): boolean => {
  const eidrRegex = /^10\.5240\/([0-9A-F]{4}-){5}[0-9A-Z]$/;

  if (
    item.eidr_code &&
    item.eidr_code.length > 0 &&
    eidrRegex.exec(item.eidr_code) === null
  ) {
    return false;
  }

  return true;
};

export const getDefaultSlug = (
  translations: SmartlistTranslation[],
): null | string => {
  if (!translations) return null;

  let trans: SmartlistTranslation | { slug: null } = { slug: null };

  translations.forEach((translation) => {
    if (translation.slug && translation.default) {
      trans = translation;
    }
  });

  return trans.slug;
};

const validateSlugUrl = (websiteUrl: string): boolean => {
  const urlRegEx = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;

  return urlRegEx.test(String(websiteUrl).toLowerCase());
};

export const slugIsValid = (slug?: string | null): boolean => {
  if (slug && !validateSlugUrl(slug)) {
    return false;
  }

  return true;
};

export const transformSlug = (slug?: string | null): string | null => {
  if (!slug) return null;

  return (replaceSpecialChars as (input: string) => string)(slug.toLowerCase());
};

export const transformSlugBeforeUpdate = (
  slug?: string | null,
): string | null => {
  if (!slug) return null;

  const slugWithoutSpecialChars = (
    replaceSpecialChars as (input: string) => string
  )(slug.toLowerCase());

  return slugWithoutSpecialChars.endsWith("-")
    ? slugWithoutSpecialChars.slice(0, -1)
    : slugWithoutSpecialChars;
};
